import React, { useEffect, useRef, useState } from "react";
import MediaSwiper from "../../../../components/CustomSwiper/MediaSwiper";
import {
  _delete_client_media,
  _get_profile_media,
  _upload_profile_media,
} from "../../../../DAL/clientTypes/ClientTpes";
import { useSnackbar } from "notistack";
import RecordNoImage from "../../../../components/recordNotFound/RecordNoImage";
import { s3baseUri } from "../../../../config/config";
import CircularLoader from "../../../../components/loader/CircularLoader";
import CustomPopoverSection from "../../../../components/menu/MebuCustomPopOverSection";
import CustomConfirmation from "../../../../components/popUp/CustomConfirmation";
import InfiniteScrollObserver from "../../../../components/InfiniteScrollContainer/InfiniteScrollContainer";
import { useIds } from "../../../../hook/AdminContext";
import { add_icon } from "../../../../assets";
import { Icon } from "@iconify/react/dist/iconify.js";
import CustomPagination from "../../../../components/CustomPagination/CustomPagination";
import SingleImagePreview from "../../../../components/SingleImagePreview/SingleImagePreview";

function AchievementListing({
  viewType,
  mediaType,
  media = [],
  handleUploadComplete = () => {},
  profile_user_id,
  handleViewAllClick = () => {},
  have_edit_access,
}) {
  const { userInfo } = useIds();
  const { enqueueSnackbar } = useSnackbar();
  const fileInputRef = useRef(null);

  const [loading, setLoading] = useState(false);
  const [loadingMedia, setLoadingMedia] = useState(true);
  const [mediaList, setMediaList] = useState(media);
  const [openDelete, setOpenDelete] = useState(false);
  const [targetDeleteItem, setTargetDeleteItem] = useState(null);

  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewSrc, setPreviewSrc] = useState("");
  // pagination states can be added here if needed
  const [totalPages, setTotalPages] = useState(0);
  const [page, setPage] = useState(0);
  const [limit] = useState(50);
  const [hasMore, setHasMore] = useState(true);

  // flags
  const is_own_profile = userInfo._id === profile_user_id;

  const handleOpenDelete = (data) => {
    console.log(data, "Delete clicked");
    setTargetDeleteItem(data);
    setOpenDelete(true);
  };
  const handleAgreeDelete = async () => {
    const resp = await _delete_client_media(targetDeleteItem._id);
    if (resp.code === 200) {
      enqueueSnackbar("Media deleted successfully", { variant: "success" });
      // Refresh media list
      fetchMedia();
      setOpenDelete(false);
    } else {
      setOpenDelete(false);
      enqueueSnackbar(resp.message, { variant: "error" });
    }
  };

  const handleButtonClick = () => {
    fileInputRef.current.click(); // Open file picker
  };

  const handleAddMedia = async (event) => {
    const files = Array.from(event.target.files);

    console.log(files, "files");

    const formData = new FormData();
    formData.append("type", mediaType);
    formData.append("status", true);

    files.forEach((file) => {
      formData.append("image", file);
    });
    setLoading(true);
    const resp = await _upload_profile_media(formData);
    if (resp.code === 200) {
      //  fetchDetails;
      enqueueSnackbar("Media uploaded successfully", { variant: "success" });

      if (viewType === "slider") {
        handleUploadComplete();
      } else {
        fetchMedia();
      }
      setLoading(false);
    } else {
      //  Handle error
      enqueueSnackbar(resp.message, { variant: "error" });
      setLoading(false);
    }
  };

  const fetchMedia = async (nextPage = 0) => {
    setLoadingMedia(true);

    const resp = await _get_profile_media(
      profile_user_id,
      mediaType,
      nextPage,
      limit
    );

    if (resp.code === 200) {
      const newMedia = resp.client_assets || [];

      setMediaList(newMedia);
      // if (nextPage === 0) {
      //   setMediaList(newMedia);
      // } else {
      //   setMediaList((prev) => [...prev, ...newMedia]);
      // }

      console.log(nextPage, "nextPage");
      setHasMore(resp.total_pages - 1 > nextPage);
      setTotalPages(resp.total_pages);
    }

    setLoadingMedia(false);
  };

  const handleLoadMore = (target_page) => {
    const nextPage = target_page - 1;
    setPage(nextPage);
    fetchMedia(nextPage);
  };

  useEffect(() => {
    fetchMedia();
  }, []);

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div className="mb-0 profile-section-heading">
          <span> {mediaType === "media" ? "Media" : "Achievements"}</span>
        </div>
        {viewType === "slider" && media.length > 0 && (
          <button
            className="btn-outlined-sm tw-group"
            onClick={() => {
              mediaType === "media"
                ? handleViewAllClick("media")
                : handleViewAllClick("achievements");
            }}
          >
            View All
          </button>
        )}

        {viewType === "all" && have_edit_access() && (
          <button
            className="btn-contained-sm tw-group"
            onClick={handleButtonClick}
          >
            <img src={add_icon} alt="" />
            {loading ? "Uploading..." : "Upload New"}
          </button>
        )}
        <input
          type="file"
          accept="image/*"
          ref={fileInputRef}
          onChange={handleAddMedia}
          style={{ display: "none" }}
          multiple
        />
      </div>

      {viewType === "slider" && (
        <>
          {media.length === 0 ? (
            <div className="text-center">
              <RecordNoImage title={`No ${mediaType} available.`} />
            </div>
          ) : (
            <MediaSwiper data={media} />
          )}
        </>
      )}

      {/* All media view */}
      {viewType === "all" && (
        <>
          {loadingMedia ? (
            <div>
              <CircularLoader />
            </div>
          ) : (
            <>
              {mediaList.length === 0 && (
                <div className="text-center">
                  <RecordNoImage title={`No ${mediaType} available.`} />
                </div>
              )}

              {mediaList.length > 0 && (
                <div className="row">
                  {mediaList.map((item, index) => (
                    <div className="col-12 col-md-6 col-lg-4 mb-3" key={index}>
                      <div className="achievement-card">
                        {have_edit_access() && (
                          <div className="action-dots">
                            <Icon
                              icon="ant-design:delete-twotone"
                              width="24"
                              height="24"
                              color="red"
                              className="media-delete-button"
                              onClick={() => handleOpenDelete(item)}
                            />
                          </div>
                        )}

                        <img
                          src={s3baseUri + item?.assets?.thumbnail_3}
                          alt={`${mediaType}-image-${index}`}
                          className="achievement-image"
                          onClick={() => {
                            setPreviewSrc(
                              s3baseUri + item?.assets?.thumbnail_4
                            );
                            setPreviewOpen(true);
                          }}
                        />
                      </div>
                    </div>
                  ))}

                  <CustomConfirmation
                    title="Are you sure you want to delete this image?"
                    headerHeading="Delete Confirmation"
                    handleAgree={handleAgreeDelete}
                    open={openDelete}
                    setOpen={setOpenDelete}
                  />
                </div>
              )}

              <SingleImagePreview
                src={previewSrc}
                show={previewOpen}
                onClose={() => setPreviewOpen(false)}
              />
            </>
          )}
          {/* Auto-load when scrolling to bottom */}

          {/* <InfiniteScrollObserver
            onLoadMore={handleLoadMore}
            hasMore={hasMore}
          /> */}
          {!loadingMedia && (
            <div>
              <CustomPagination
                totalPages={totalPages}
                page={page + 1}
                onPageChange={(val) => {
                  handleLoadMore(val);
                }}
              />
            </div>
          )}
        </>
      )}
    </>
  );
}

export default AchievementListing;
